import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchRankingListFail,
	fetchRankingListSuccess,
	initRankingList,
	refreshRankingList,
	updateIncludePublic,
} from './ranking.actions';
import { RankingState } from './ranking.state';

export const rankingReducer = createReducer<RankingState>(
	new RankingState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initRankingList, refreshRankingList, (state) => state.setLoading(true)),
	on(fetchRankingListFail, (state) => state.setLoading(false)),
	on(fetchRankingListSuccess, (state, action) =>
		state.setLoading(false).setRankingList(action.rankingList)
	),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	)
);
